import React from 'react'
import styled from '@emotion/styled'

import ArrowNext from '../../images/icons/arrow-next.svg'
import ArrowDown from '../../images/icons/arrow-down.svg'
import ArrowUp from '../../images/icons/arrow-up.svg'
import BurgerIcon from '../../images/icons/burger-menu.svg'
import BurgerIcon2 from '../../images/icons/burger.svg'
import CloseIcon from '../../images/icons/burger-menu-cross.svg'
import ChevronDown from '../../images/icons/chevron-down.svg'
import ChevronUp from '../../images/icons/chevron-up.svg'
import PlayIcon from '../../images/icons/play-icon.svg'
import LineArrowLeft from '../../images/icons/Line-Arrow-Left.svg'
import LineArrowRight from '../../images/icons/Line-Arrow-Right.svg'
import FilterIcon from '../../images/icons/filter.svg'

export const icons = {
  play: <PlayIcon />,
  'right-arrow': <ArrowNext />,
  'down-arrow': <ArrowDown />,
  'up-arrow': <ArrowUp />,
  'line-arrow-left': <LineArrowLeft />,
  'line-arrow-right': <LineArrowRight />,
  'chevron-down': <ChevronDown />,
  'chevron-up': <ChevronUp />,
  burger: <BurgerIcon />,
  burger2: <BurgerIcon2 />,
  close: <CloseIcon />,
  'filter': <FilterIcon />,
}

export type IconProps = {
  kind: keyof typeof icons
  strokeColor?: string
  fillColor?: string
  size?: string | number
}

export const Icon: React.FC<IconProps> = ({ kind, strokeColor, fillColor, size = '16px' }) => {
  const Wrapper = styled.i`
    svg {
      display: block;
      stroke: ${strokeColor};
      fill: ${fillColor};
      width: ${typeof size === 'number' ? `${size}px` : size};
      height: ${typeof size === 'number' ? `${size}px` : size};
    }
  `

  return <Wrapper aria-hidden="true">{icons[kind]}</Wrapper>
}
